[{
        "coreStep": "Authorizations & Suggested Final Lines",
        "generalTask": "Quote Sheet Update",
        "actionDetails": "<ul><li>Update quote sheet with market authorizations<\/li><li>Review authorizations for any subjectivities or contractual provision amendments<\/li><li>Determine appropriate action for subjectivities, non-concurrencies and contract amendments, advise Client and markets accordingly. Secure Client and market agreement to non-concurrent language.<\/li><li>If changes to FOT contract are determined appropriate, repeat \"Firm Order Contract\" steps<\/li><\/ul>",
        "responsibility": "BT\/CD",
        "cemRequirement": "No",
        "guidanceReferenceLink": "<a href=\"https:\/\/ajg0.sharepoint.com\/sites\/gre-Gateway\/_layouts\/15\/download.aspx?UniqueId=fe24d972%2D0abc%2D4437%2Da00b%2De78f08e75de7\" target=\"_self\" rel=\"noopener\">Non-Concurrency Handling<\/a>"
    },
    {
        "coreStep": "Authorizations & Suggested Final Lines",
        "generalTask": "Proposed Final Lines",
        "actionDetails": "<ul><li>Prepare proposed final signed lines<\/li><li>If any suggested final signed line is outside the parameters of the markets stipulation, obtain written acceptance of that suggested final signed line from the applicable market(s)<\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "No",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Authorizations & Suggested Final Lines",
        "generalTask": "SPOE",
        "actionDetails": "<ul><li>Send market authorizations and suggested final lines to an authorized SPOE for review and approval<\/li><li>Include Broker Team, Contract Drafter and Ops Specialist on email<\/li><\/ul>",
        "responsibility": "BT\/CD",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": "<a href='https://ajg0.sharepoint.com/sites/gre-Gateway/_layouts/15/download.aspx?UniqueId=b2690527%2Deb94%2D4938%2D917c%2D548936b13995', target = \"_self\">GEM Authorized Second Pair of Eyes List<\/a>"
    },
    {
        "coreStep": "Authorizations & Suggested Final Lines",
        "generalTask": "Send to Client",
        "actionDetails": "<ul><li>Send the market authorizations and suggested final lines to the Client using appropriate Template Text<\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Authorizations & Suggested Final Lines",
        "generalTask": "Client Approval",
        "actionDetails": "<ul><li>Obtain written Client's agreement to final signed lines<\/li><li>Send final signed lines to Ops Specialist and Contract Drafter<\/li><\/ul><strong>Note: Should client's approved final signed lines fall outside of a market's authorization or subjectivity, must repeat \"Proposed Final Lines\" and SPOE steps above for affected market(s). Following market(s) agreement, send updated confirmation of coverage to the client<\/strong>",
        "responsibility": "BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Placement Not Fully Subscribed by Inception Date",
        "generalTask": "Notify Client",
        "actionDetails": "<ul><li>Notify Client on incomplete status of the placement<\/li><li>Secure written instruction from Client - continue with placement, bind lines currently authorized, close placement<\/li><\/ul><strong>Note 1: If binding lines at current authorizations, must complete Authorization & Suggested Final Lines steps above<\/strong><br\/>Note 2: Even if a client is fully aware and comfortable with a partially placed program at renewal/inception  we still must confirm the placement status to the client in writing.",
        "responsibility": "BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Placement Not Fully Subscribed by Inception Date",
        "generalTask": "Notify Branch Manager",
        "actionDetails": "<ul><li>Notify the Branch Manager and National Branch Leadership<\/li><li>Notification to include confirmation of advises to Client of incomplete status, Client's instructions and what steps are being taken to finalize the placement<\/li><li>Include Ops Specialist and Contract Drafter on email<\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Non-Concurrent Terms ",
        "generalTask": "Send to Client",
        "actionDetails": "<ul><li>Send the Client all proposed non-concurrent terms including the required Template Text<\/li><li>Include Contract Drafter on email<\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": "<a href=\"https:\/\/ajg0.sharepoint.com\/:b:\/r\/sites\/gre-Gateway\/_layouts\/15\/download.aspx?sourceurl=\/sites\/gre-Gateway\/Content\/Center\/RQM\/CEM\/Gateway\/Non-Concurrency%20Handling.pdf\" target = \"_self\" rel=\"noopener\">Non-Concurrency Handling<\/a>"
    },
    {
        "coreStep": "Non-Concurrent Terms ",
        "generalTask": "Client Approval",
        "actionDetails": "<ul><li>Obtain Client's written agreement to non-concurrent terms<\/li><li>Identify and follow Client's written instruction on disclosing non-concurrency to other markets<\/li><li>Obtain Client's written instructions for documenting non-concurrencies - within a separate contract or within the I&L's<\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": "<a href=\"https:\/\/ajg0.sharepoint.com\/:b:\/r\/sites\/gre-Gateway\/_layouts\/15\/download.aspx?sourceurl=\/sites\/gre-Gateway\/Content\/Center\/RQM\/CEM\/Gateway\/Non-Concurrency%20Handling.pdf\" target = \"_self\" rel=\"noopener\">Non-Concurrency Handling<\/a>"
    }
]
